module.exports = __webpack_public_path__ + "static/img/summer_banner.8d28e2ba.jpg";